import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { CommonInsurerRequestDTO } from '@shared/dtos';
import {
  HandlerRequestData,
  IContactEmail,
  IContactInsurerLeads,
  IName,
  ISendRequestData,
  ISharedTo,
} from '@shared/interfaces';
import { emailValidator, getArrangedName } from '@shared/utils';

import { AdditionalDetailsData } from '../../../bms-shared/popups/new-send-request-updated/additional-details/form-data';
import { EmailSuggestionService } from '../../../../services/email-suggestion.service';

export enum SUPERVISOR_DECISIONS {
  RESOLVE = 'RESOLVE',
  REJECT = 'REJECT',
}

export interface ISendRequestPopupReturnData {
  subject?: string;
  remarks: string;
  ccEmails: string[];
  email: string[];
  allEmails: string[];
  formattedMails: CommonInsurerRequestDTO[];
}
export interface PopupReturnData {
  additionalEmailData: AdditionalDetailsData;
  documentData: {
    docs_store: {
      files: File[];
    };
  };
  sharedData: ISharedTo[];
}

@Component({
  selector: 'app-endorsement-request-popup',
  templateUrl: './send-request-popup.component.html',
  styleUrls: ['./send-request-popup.component.scss'],
})
export class SendRequestPopupComponent implements OnInit {
  selectedDecision: SUPERVISOR_DECISIONS = SUPERVISOR_DECISIONS.RESOLVE;
  SUPERVISOR_DECISIONS = SUPERVISOR_DECISIONS;

  isIdentitiesModuleEnabled: boolean;
  identitiesModulesSub: Subscription;
  responseFormGroup = new FormGroup({
    subject: new FormControl<string>(''),
    additionalEmails: new FormControl(null, [emailValidator()]),
    remarks: new FormControl<string>(null),
  });

  liaisonAgentIndex: number;
  resend: boolean;
  separatorKeyCodes: number[] = [ENTER, COMMA]; // Allow Enter and Comma to separate emails
  addedEmails: string[] = [];
  ccEmails: string[] = [];
  AllEmails: string[] = [];
  emailValidationError = false;

  handlers: HandlerRequestData[] = [];

  sendContacts: IContactInsurerLeads[] = [];
  constructor(
    private matDialog: MatDialogRef<SendRequestPopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    private data: {
      sendRequestData: ISendRequestData;
      handlers: HandlerRequestData[];
    },
    private emailSuggestionService: EmailSuggestionService
  ) {
    if (data?.sendRequestData?.resend) {
      this.resend = this.data.sendRequestData.resend;
    }

    if (data?.handlers && data?.handlers?.length > 0) {
      this.handlers = data.handlers || [];
    }
  }

  ngOnInit(): void {
    this.sendContacts = this.data.sendRequestData?.data;
    const defaultSubject =
      this.data.sendRequestData?.subject ||
      this.data.sendRequestData?.title ||
      '';
    this.responseFormGroup.controls.subject.setValue(defaultSubject);

    if (this.data.sendRequestData?.isRemarksRequired) {
      this.responseFormGroup.controls.remarks.addValidators([
        Validators.required,
      ]);
    }
  }
  onDecisionChange(e: SUPERVISOR_DECISIONS) {
    this.selectedDecision = e;
  }
  onClickClose() {
    this.matDialog.close();
  }

  addEmail(email: string): void {
    this.emailValidationError = false; // Reset error state
    email = email.trim();

    if (email && this.isValidEmail(email)) {
      if (!this.addedEmails.includes(email)) {
        this.addedEmails.push(email); // Add unique, valid email
        this.emailSuggestionService.saveEmail(email).subscribe();
      }
    } else if (email) {
      this.emailValidationError = true; // Set error if invalid email
    }
  }

  removeEmail(email: string): void {
    const index = this.addedEmails.indexOf(email);
    if (index >= 0) {
      this.addedEmails.splice(index, 1);
    }
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  getPrimaryEmail(email: IContactEmail[]): string {
    return email.find((e) => e.is_primary).email;
  }

  getArrangedName(name: IName): string {
    return getArrangedName(name);
  }

  /**
   * Toggle handler checkbox selection
   */
  onHandlerCheckboxChange(index: number, checked: boolean): void {
    if (checked) {
      this.handlers[index].isSelected = true;
      // for client request check box enable for all
    } else {
      this.handlers[index].isSelected = false;
    }
  }

  outputData() {
    this.data?.sendRequestData?.data?.map((contact) => {
      contact?.email?.map((email) => {
        this.ccEmails.push(email.email);
      });
    });
    const formattedMails: CommonInsurerRequestDTO[] =
      this.data.sendRequestData.data.map((e) => ({
        email: this.getPrimaryEmail(e.email),
        isLiaising: e.is_liaison_agent,
        name: e.name,
      }));

    this.handlers.forEach((handler) => {
      if (handler.isSelected) {
        formattedMails.push({
          email: handler.email,
          isLiaising: false,
          name: handler.name,
        });

        this.ccEmails.push(handler.email);
      }
    });
    this.AllEmails = this.addedEmails.concat(this.ccEmails);
    this.matDialog.close({
      subject: this.responseFormGroup.value.subject,
      remarks: this.responseFormGroup.value.remarks,
      ccEmails: this.ccEmails,
      email: this.addedEmails,
      allEmails: this.AllEmails,
      formattedMails,
    });
  }
}
